export default class Swipers {

    initSwiperProjects() {
        const flag = document.querySelectorAll(".js-swiper-projects .swiper-slide")?.length > 2;
        const swiper = new Swiper(".js-swiper-projects", {
            centeredSlides: flag,
            slidesPerView: 1.1,
            spaceBetween: 20,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 40
                },
                990: {
                    slidesPerView: 3,
                    spaceBetween: 30
                }
            },
            pagination: {
                el: ".js-swiper-projects .swiper-cards-inline-pagination",
                clickable: true
            }
        });

        return swiper;
    }

    initSwiperNumbers() {        
        const swiper = new Swiper(".js-swiper-numbers", {
            slidesPerView: 1.1,
            spaceBetween: 12,
            pagination: {
                el: ".js-swiper-numbers .swiper-pagination",
                clickable: true
            }
        });

        return swiper;
    }
}